import React from 'react';
import Wrapper from './StyledPage';

export const News = () => {
  return <Wrapper>News</Wrapper>;
};
